<template>
  <div class="Page">
    <b-container class="content">
      <b-row>
        <b-col>
          <p>
            <strong>As part of The Building Blocks's Emergency Assistance process, we need you to read and sign the following release of information consent form. If you do not sign the agreement below, you will not be able to proceed with the application.</strong>
          </p>
          <h2>
            <strong>Why do we collect information about you for application and how do we store it?</strong>
          </h2>
          <p>The personal information collected about you is used by caseworkers only to process your application by allowing us to speak to your references, landlord, vendors of the services you need assistance with, and other community organizations as needed to secure further funds. The Building Blocks will store your information following privacy laws and guidelines.</p>
          <p>Your information will be stored on a secure electronic database. You may access or correct the information by contacting our office. If you have a concern about the information collected or how we use it, please contact our office via email or phone.</p>
          <p>Failure to provide requested information will result in automatic denial of your application, as we will not be able to verify your situation or speak to necessary individuals such as vendors and landlords without a signed release of information form.</p>
          <p>Upon submitting your application, you will receive an email containing a PDF copy of your application and further instructions.</p>         
         
          <h2>
            <strong>What are we doing with information you provide to us online?</strong>
          </h2>
          <p>Building Blocks will also receive a copy of your application, and a caseworker will contact you within 2-3 business days to update you on the status of your application. </p>
        </b-col>
      </b-row>

      <!-- privacy policy acceptance -->
      <b-row>
        <b-col>
          <b-card class="card--grey">
            <h2>Please confirm you accept the Release of Information agreement, to proceed with your application. </h2>
            <p>
              If you do not agree, you will not be able to proceed with the Emergency Assistance process.               
            </p>
            <AppCheckbox
              value="No"
              trueValue= "Yes"
              falseValue= "No"
              label="I agree to the Privacy Agreement"
              @change="setPrivacyAgreement"
              />
          </b-card>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col md="3">
          <b-button variant="primary" :disabled="!isAgreed" @click="goLogin">Continue</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AppCheckbox from '@/components/app/AppCheckbox.vue'

export default {
  name: 'Page',
  components: { AppCheckbox },
  data() {
    return {
      isAgreed: false,      
      privacyBaseUrl:
        'https://thebuildingblocks.org'
    }
  }, 
  methods: {
    goLogin() {
     
        this.$router.history.push('/login/new')
     
    },
    setPrivacyAgreement(e) {
      this.isAgreed = e === 'Yes'
    }
  }
}
</script>

<style lang="scss" scoped>
.Page {
  padding: 60px 0 20px;
  //owl selector to set consistent spaces between all html elements no matter how deeply they are nested, thanks to Heydon Pickering https://alistapart.com/article/axiomatic-css-and-lobotomized-owls/
  * + * {
    margin-top: 1.5rem;
    margin-bottom: 0;
  }
  .content.container {
    padding: 40px 15px 0;
  }

  .content {
    margin: 0 auto;
    padding: 30px;
    text-align: left;

    h2 {
      padding: 2rem 0;
    }

    li {
      font-size: 1.6rem;
    }

    a {
      font-weight: bold;
    }
  }

  .fade-enter-active {
    transition: all 0.8s ease-in;
  }

  .fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter {
    transform: translateY(-5px);
  }

  .fade-leave-to {
    transform: translateY(5px);
  }

  .card {
    border: 2px solid $color-primary;
    border-radius: $card-border-radius;
  }

  .card--grey {
    background: $color-grey-5;
    color: $color-primary;
    h2 {
      padding: 0;
    }
  }

  .card-body {
    padding: 2.3rem;
  }

  &::v-deep .AppCheckbox {
    font-weight: bold;
    input {
      left: 0;
    }
    span:before,
    span:after {
      left: 0;
    }
  }

  .btn {
    width: 100%;
    margin-left: 0;
    &:disabled {
      background: $color-grey-60;
      color: $color-white;
      border-color: $color-grey-60;
      cursor: not-allowed;
    }
  }
}
</style>
